import { render, staticRenderFns } from "./ProductContentBG.vue?vue&type=template&id=2e3bdb5a&"
import script from "./ProductContentBG.vue?vue&type=script&lang=js&"
export * from "./ProductContentBG.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentBG.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports